import { Center } from '@tempots/beatui'
import { attr, html } from '@tempots/dom'
import { SampleResumeLink } from './sample-resume-link'

export function BrandResumePanel({
  setResumeFile,
}: {
  setResumeFile: (file: File | null) => void
}) {
  return Center(
    {},
    html.div(
      attr.class('flex flex-col gap-1 md:gap-4 p-4 md:p-8'),
      html.h2(
        attr.class('text-gray-800 text-lg md:text-xl font-semibold'),
        'Brand your resume'
      ),
      html.ul(
        attr.class(
          'text-xs md:text-sm text-gray-600 mb-2 space-y-1 list-disc pl-4'
        ),
        html.li(
          attr.class('text-gray-600'),
          html.span(
            attr.class('hidden md:inline'),
            'Upload a resume by dropping it anywhere on this page, or click the button in the top right to browse.'
          ),
          html.span(
            attr.class('md:hidden'),
            'Upload a resume using the drop zone above.'
          )
        ),
        html.li(
          SampleResumeLink(
            { setResumeFile },
            'Or click here to use a sample resume.'
          )
        ),
        html.li(
          attr.class('text-gray-600'),
          'Update your recruiter and agency fields to see a live preview.'
        ),
        html.li(
          attr.class('text-gray-600'),
          'Download the resume with the button below'
        ),
        html.li(
          attr.class('text-gray-600 font-semibold'),
          'Save your information for future resumes by signing up!'
        )
      )
    )
  )
}
